import { createRoute } from '@tanstack/react-router'
import { rootRoute } from './root'
import { AuditLogPage } from '../features/audit-log/page'

export const auditLogRoute = createRoute({
  path: 'audit-log',
  getParentRoute: () => rootRoute,
  component: AuditLogPage,
})
